import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { FaTimes } from 'react-icons/fa'
import { getLatestPost } from '../blog/posts'
import { LocalizedLink, useTranslation, useLang } from '../lib/i18n'
import { small } from '../lib/media_query'

const Banner = styled.div`
    background: linear-gradient(135deg, ${(props) => props.theme.palette.brand.blue}, ${(props) => props.theme.palette.brand.green});
    color: white;
    padding: 10px 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 10;

    ${small(`
        padding: 10px 40px;
    `)}
`

const NewBadge = styled.span`
    background: white;
    color: ${(props) => props.theme.palette.brand.blue};
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 20px;
    margin-right: 12px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    white-space: nowrap;
    flex-shrink: 0;
`

const BannerText = styled(LocalizedLink)`
    color: white;
    text-decoration: none;
    font-size: 14px;
    text-align: center;

    &:visited {
        color: white;
    }

    &:hover {
        text-decoration: underline;
        color: white;
    }

    ${small(`
        font-size: 13px;
    `)}
`

const CloseButton = styled.button`
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: white;
    opacity: 0.75;
    display: flex;
    align-items: center;
    padding: 6px;
    font-size: 14px;
    line-height: 1;

    &:hover {
        opacity: 1;
    }
`

export default function AnnouncementBanner() {
    const { pathname } = useLocation()
    const { t } = useTranslation(undefined, { keyPrefix: 'banner' })
    const latestPost = getLatestPost(useLang())
    const dismissKey = `banner_dismissed_${latestPost.slug}`
    const [dismissed, setDismissed] = useState(true)

    useEffect(() => {
        try {
            if (!localStorage.getItem(dismissKey)) {
                setDismissed(false)
            }
        } catch (e) { }
    }, [dismissKey])

    const dismiss = () => {
        try {
            localStorage.setItem(dismissKey, '1')
        } catch (e) { }
        setDismissed(true)
    }

    if (dismissed || pathname.startsWith('/plus')) {
        return null
    }

    return (
        <Banner>
            <NewBadge>{t('badge')}</NewBadge>
            <BannerText to={`/blog/${latestPost.slug}`}>
                {t('text', { title: latestPost.title })}
            </BannerText>
            <CloseButton onClick={dismiss} aria-label={t('dismiss')}>
                <FaTimes />
            </CloseButton>
        </Banner>
    )
}
